module.exports = __webpack_public_path__ + "static/media/048.32251c5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/048.jpg
// module id = 393
// module chunks = 0